class CustomEventWithDefaults extends CustomEvent {
  constructor(name, eventInitDict) {
    super(name, {
      bubbles: true,
      cancelable: false,
      composed: true,
      detail: {},
      ...eventInitDict
    });
  }
}

export { CustomEventWithDefaults };
